import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ToastService } from '../services/toast.service';
import { NotificationType } from '../enums/notificationType';

@Injectable()
export class Http504Interceptor implements HttpInterceptor {
  constructor(private toastService: ToastService) {}
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<any> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 504) {
          this.showToast(
            'Er is iets mis gegaan, mogelijk wordt SkillCentral geblokkeerd door uw IT of netwerk provider. Neem contact op met uw IT provider of netwerk provider.'
          );
        }
        return throwError(() => error);
      })
    );
  }

  private showToast(message: string): void {
    this.toastService.show('Error', message, NotificationType.Error);
  }
}
